import React from 'react';
import SlotWrapper from '../SlotWrapper';

const ConsentButtons = ({
  onSkipToGeneralChat,
  onPersonalize,
  className = '',
  ...props
}) => {
  return (
    <SlotWrapper className={className} {...props}>
      <div
        className="
          bubble-consent-buttons
          flex
          items-start
          gap-v3-xs
          self-stretch
        "
      >
      {/* Skip to general chat button */}
      <button
        onClick={onSkipToGeneralChat}
        className="
          flex
          h-10
          px-6
          py-v3-xs
          flex-col
          justify-center
          items-center
          flex-1
          rounded-v3-xl
          bg-v3-purple-lightest
          text-v3-purple-primary
          text-center
          font-inter-variable
          text-sm
          font-medium
          leading-[160%]
          transition-all
          duration-200
          hover:bg-v3-purple-light
          active:scale-95
        "
      >
        Skip to general chat
      </button>

      {/* Yes, let's personalize button */}
      <button
        onClick={onPersonalize}
        className="
          flex
          h-10
          px-6
          py-v3-xs
          flex-col
          justify-center
          items-center
          flex-1
          rounded-v3-xl
          bg-v3-purple-primary
          text-white
          text-center
          font-inter-variable
          text-sm
          font-medium
          leading-[160%]
          transition-all
          duration-200
          hover:bg-v3-purple-dark
          active:scale-95
        "
      >
        Yes, let's personalize
      </button>
      </div>
    </SlotWrapper>
  );
};

export default ConsentButtons;
